import type { FaireProductEntity } from "../../entity_types/product";

export const p_fpvfwuce93: FaireProductEntity = {
  token: "p_fpvfwuce93",
  type: "product",
  name: "Lesley Elizabeth Dill & Tarragon Sea Salt (250mL PET)",
  brandToken: "b_wc2q3m3rxc",
  brandName: "Hongar Farms",
  imageUrl:
    "https://cdn.faire.com/fastly/10e4c65f3ff4a95efa1125292526d1fd2de9af4caeff3bd13be1510eb51f8ec6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/919136a962a011716670b315bc27650857f8167198a091ed1e979adae6734fec.png",
    "https://cdn.faire.com/fastly/579b5521cf3db636971f6c90e49294a67fb6d34a4bccb114a3d9291447c3ac2f.png",
    "https://cdn.faire.com/fastly/b2040f399c98649d2a6e303e5fa9bf7a5f233e09be37ebd7932781c875b995eb.png",
    "https://cdn.faire.com/fastly/10073239208e21f1368588120bababf425f2d1620d1714ab46aff5fde103c232.png",
  ],
  priceDollars: 6.03,
  description:
    "Bring fresh, herbaceous flavor to your cooking with Lesley Elizabeth’s Dill & Tarragon Seasoned Sea Salt. This gourmet blend pairs fragrant dill and tarragon with premium sea salt for a delicate, savory finish that complements seafood, poultry, and vegetables. Use it as a rub by drizzling with oil and seasoning generously, or sprinkle as a finishing salt for an elegant touch. Stir into salad dressings, marinades, or sauces for a bright, herbal twist. Small-batch crafted and packed in a 250mL PET shaker, this versatile blend is a must-have for kitchens that crave fresh, refined flavor with ease.",
  tags: [],
  msrpDollars: 12.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:08.559Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
